/* js/pages/AboutPage.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import Header from '../components/Header.svelte';
import { db } from '../Db';

function create_fragment(ctx) {
	let header;
	let t0;
	let div5;
	let div0;
	let t1;
	let html_tag;
	let raw_value = /*content*/ ctx[0].html + "";
	let t2;
	let div3;
	let t4;
	let div4;
	let current;
	header = new Header({ props: { title: "à propos" } });

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div5 = element("div");
			div0 = element("div");
			t1 = space();
			html_tag = new HtmlTag();
			t2 = space();
			div3 = element("div");

			div3.innerHTML = `<div class="logo-bm svelte-1700tqf"><img class="logo svelte-1700tqf" src="/images/logo_bm.png" alt=""/></div> 

        <div class="logo-ville svelte-1700tqf"><img class="logo svelte-1700tqf" src="/images/logo_ville.png" alt=""/></div>`;

			t4 = space();
			div4 = element("div");
			attr(div0, "class", "headspacer");
			html_tag.a = t2;
			attr(div3, "class", "home-footer svelte-1700tqf");
			attr(div4, "class", "footerspacer");
			attr(div5, "class", "column");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div5, anchor);
			append(div5, div0);
			append(div5, t1);
			html_tag.m(raw_value, div5);
			append(div5, t2);
			append(div5, div3);
			append(div5, t4);
			append(div5, div4);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div5);
		}
	};
}

function instance($$self) {
	let content = db.aboutContent;
	return [content];
}

class AboutPage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default AboutPage;